var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { commonCSS } from "../common";
import { mainStyles, largeStyles, regularStyles, smallStyles } from "./styles";
export default styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n  /* calculate size responsively if not specified */\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n  ", "\n  ", "\n\n  /* calculate size responsively if not specified */\n\n  ",
    "\n\n  ", "\n"])), mainStyles, function (_a) {
    var small = _a.small;
    return small && smallStyles;
}, function (_a) {
    var regular = _a.regular;
    return regular && regularStyles;
}, function (_a) {
    var large = _a.large;
    return large && largeStyles;
}, function (_a) {
    var small = _a.small, regular = _a.regular, large = _a.large, theme = _a.theme;
    return !small &&
        !regular &&
        !large && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ",
        "\n\n    ",
        "\n  "])), smallStyles, theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), regularStyles), theme.mediaQueries.minWidthMedia.desktop(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), regularStyles));
}, commonCSS);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
